// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ragsrcEntity from './entities/ragsrc.json';
import ragsrcMenu from '../pages/ragsrc/menu.json';
import ragsrcFullForm from '../pages/ragsrc/forms/full.json';
import ragsrcContextForm from '../pages/ragsrc/forms/context.json';
import ragsrcMiniForm from '../pages/ragsrc/forms/mini.json';
import ragsrcLookupForm from '../pages/ragsrc/forms/lookup.json';
import ragsrcTableView from '../pages/ragsrc/views/table.json';
import ragsrcStagesView from '../pages/ragsrc/views/stages.json';
import ragsrcCardsView from '../pages/ragsrc/views/cards.json';
import ragsrcInlineView from '../pages/ragsrc/views/inline.json';
import ragsrcBacklogView from '../pages/ragsrc/views/backlog.json';
import ragsrcSplitView from '../pages/ragsrc/views/split.json';
import ragsrcCalendarView from '../pages/ragsrc/views/calendar.json';
import ragsrcDashboardView from '../pages/ragsrc/views/dashboard.json';

/** Тип запису «Джерело» зі сторінками пакета: меню, форми та подання з pages/ragsrc/. */
export const ragsrcDefinition: IRecordTypeDefinition = {
  ...ragsrcEntity,
  views: assembleViewSet({
      table: ragsrcTableView,
      stages: ragsrcStagesView,
      cards: ragsrcCardsView,
      inline: ragsrcInlineView,
      backlog: ragsrcBacklogView,
      split: ragsrcSplitView,
      calendar: ragsrcCalendarView,
      dashboard: ragsrcDashboardView,
  }),
  form: ragsrcFullForm,
  forms: { full: ragsrcFullForm, context: ragsrcContextForm, mini: ragsrcMiniForm, lookup: ragsrcLookupForm },
  menu: ragsrcMenu,
} as IRecordTypeDefinition;
